<template>
  <v-dialog v-model="dialog" width="600px" :fullscreen="$vuetify.breakpoint.smAndDown" scrollable>
    <v-card>
      <v-card-title class="primary white--text">
        <v-toolbar-title>XEM HỒ SƠ XE</v-toolbar-title>
        <v-spacer />
        <v-icon color="white" @click="cancel">close</v-icon>
      </v-card-title>
      <v-card-text>
        <div class="mt-4">
          <h3 class="mt-2">1. Thông tin cơ bản</h3>
          <div class="d-flex">
            <div style="width: 300px">Tên tuyến xe:</div>
            <div>{{ item.stt || '' }}</div>
          </div>
          <h3 class="mt-2">2. Thông tin xe</h3>
          <div class="d-flex">
            <div style="width: 300px">Biển số xe:</div>
            <div>{{ item.licensePlate }}</div>
          </div>
          <div class="d-flex">
            <div style="width: 300px">Đăng kí xe:</div>
            <div>{{ item.carRegistration }}</div>
          </div>
          <div class="d-flex">
            <div style="width: 300px">Ngày đăng kiểm:</div>
            <div>{{ item.inspection }}</div>
          </div>
          <h3 class="mt-2">3. Thông tin tài xế</h3>
          <div class="d-flex">
            <div style="width: 300px">Tên tài xế:</div>
            <div>{{ item.driver }}</div>
          </div>
          <div class="d-flex">
            <div style="width: 300px">CCCD:</div>
            <div>{{ item.cccd }}</div>
          </div>
          <div class="d-flex">
            <div style="width: 300px">Giấy phép lái xe:</div>
            <div>{{ getDataBoolean(item.driverLicense) }}</div>
          </div>
          <div class="d-flex">
            <div style="width: 300px">Sơ yếu lý lịch:</div>
            <div>{{ getDataBoolean(item.resume) }}</div>
          </div>
          <div class="d-flex">
            <div style="width: 300px">Giấy khám sức khỏe:</div>
            <div>{{ getDataBoolean(item.healthCertificate) }}</div>
          </div>
          <div class="d-flex">
            <div style="width: 300px">GCN tập huấn nghiệp vụ lái xe KDVT:</div>
            <div>{{ item.certificateTransportDriver }}</div>
          </div>
          <div class="d-flex">
            <div style="width: 300px">CN bảo hiểm bắt buộc:</div>
            <div>{{ item.insuranceCertificate }}</div>
          </div>
          <div class="d-flex">
            <div style="width: 300px">GCN hộ kinh doanh cá thể:</div>
            <div>{{ item.certificateHousehold }}</div>
          </div>
          <div class="d-flex">
            <div style="width: 300px">Giấy phép KDVT bằng ô tô:</div>
            <div>{{ item.motorLicense }}</div>
          </div>
          <div class="d-flex">
            <div style="width: 300px">Ghi chú:</div>
            <div>{{ item.note }}</div>
          </div>
        </div>
      </v-card-text>

      <v-card-actions>
        <v-btn class="ma-2" outlined light @click="cancel" width="100px">ĐÓNG</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  data() {
    return {
      dialog: false,
      item: null
    }
  },
  methods: {
    openDialog(item) {
      this.item = item
      this.dialog = true
    },

    cancel() {
      this.dialog = false
    },

    getDataBoolean(data = false) {
      return data ? 'Đủ' : 'Chưa có'
    }
  }
}
</script>
